<template>
  <div
    id="app"
    :class="{ fullScreen: fullScreen }"
    :style="{ height: `${clientHeight}px` }"
  >
    <NavBar></NavBar>
    <div class="page-frame">
      <RouterView></RouterView>
    </div>
    <div class="horizontal">
      <div class="icon"></div>
      <!-- <p>横屏浏览 体验更佳</p> -->
       <div class="font-bold"> 
        <div class="font-text">体验功能 需横屏浏览</div>
        <br/>
        <div class="font-text">在设置中打开屏幕「自动旋转」功能</div>
        <div class="font-text">横屏展示赛事中心内容</div>
        <!-- <div></div> -->
       </div>
       
    </div>
    <!--活动结束遮罩: 由 config.json 的 event_end_time 驱动, 测试用 ?stage=4-->
    <div v-if="eventEnded" class="tempEndMask">
        活动已结束
    </div>
    <!-- 全局 toast: 任何组件调 usePrompt().showPrompt(msg) 都会在这里显示 -->
    <UiPrompt />
  </div>
</template>

<script setup>
import { onBeforeMount, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useRoute } from 'vue-router'
import { useSessionStore, useStageStore, useUiStore } from '@/store'
import NavBar from '@/views/nav-bar'
import UiPrompt from '@/components/ui-prompt'
import { resolveInitialToken } from '@/composables/useSessionBootstrap'
import { useTapdb } from '@/composables/useTapdb'
import { useViewportScale } from '@/composables/useViewportScale'

const route = useRoute()
const sessionStore = useSessionStore()
const uiStore = useUiStore()
const stageStore = useStageStore()

const { fullScreen } = storeToRefs(uiStore)
const { eventEnded } = storeToRefs(stageStore)
const { clientHeight } = useViewportScale(uiStore)
const { initTapdb } = useTapdb(uiStore)

watch(
  () => route.name,
  (newVal) => {
    uiStore.setCurrentPage(newVal)
  },
  { immediate: true }
)

onBeforeMount(() => {
  // config 已在 main.js 提前触发加载 (先于 router.isReady 首次导航), 这里只处理 token / tapdb
  const token = resolveInitialToken(route)
  if (!token) {
    console.warn('token is null')
    return
  }

  sessionStore.setToken(encodeURIComponent(token))
  initTapdb()
})
</script>

<style lang="scss">
@import '~@/assets/common/base';
@import '~@/assets/app';

.tempEndMask {
  position:absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 6vh;
  z-index: 10000;
}
</style>
